export default __webpack_public_path__ + "static/media/abbeville7.b1049eb2.jpg";